module.exports = __webpack_public_path__ + "ptc_momoro_G2.818b7b7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_G2.jpg
// module id = SwRw
// module chunks = 0